import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { ErrorBoundary } from '@sainsburys-tech/bolt'
import { trackLhnCategorySelect } from '../../helpers/TaggingSerializer'
import { getBrand } from '../../utils/ConfigProvider'
import * as Styled from './styles'

const Category = ({ itemName, id, categoryPath, type }) => {
  const isHabitat = getBrand() === 'habitat'

  const onClick = event => {
    if (isHabitat) {
      event.preventDefault()
      trackLhnCategorySelect(itemName, id)
      window.location.href = categoryPath
    } else {
      window.scrollTo(0, 0)
      trackLhnCategorySelect(itemName, id)
    }
  }

  return (
    <ErrorBoundary>
      <Styled.CategoryItemWrapper as='li' data-el='category-item'>
        <Styled.CategoryLink
          as={isHabitat ? 'a' : Link}
          data-category-id={id}
          onClick={event => onClick(event)}
          {...(isHabitat && { href: categoryPath })}
          {...(!isHabitat && {
            to: {
              pathname: categoryPath,
              state: { type }
            }
          })}>
          {itemName}
        </Styled.CategoryLink>
      </Styled.CategoryItemWrapper>
    </ErrorBoundary>
  )
}

Category.propTypes = {
  id: PropTypes.string.isRequired,
  itemName: PropTypes.string.isRequired,
  categoryPath: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired
}

export default Category
